import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/school/types';
import {
  stateKeys,
  stateLoadingKeys
} from '../../constants/school-public-vacancies';

const initialState = Immutable.fromJS({
  isLoading: false,
  schoolPublicProfile: null,
  schoolPublicVacancies: [],
  schoolPublicProfileFailedCode: null,
  schoolPublicVacanciesFailedCode: null
});

export default reducerCreator(initialState, {
  [types.SCHOOL_SET_LOADING]: (state, { isLoading, part }) => {
    if (stateLoadingKeys[part]) {
      return state.set(stateLoadingKeys[part], isLoading);
    }

    return state;
  },
  [types.SCHOOL_SET_PUBLIC_PROFILE]: (state, { schoolPublicProfile }) =>
    state.set(stateKeys.schoolPublicProfile, schoolPublicProfile),
  [types.SCHOOL_SET_PUBLIC_VACANCIES]: (state, { schoolPublicVacancies }) =>
    state.set(stateKeys.schoolPublicVacancies, schoolPublicVacancies),
  [types.SCHOOL_SET_SCHOOL_PUBLIC_PROFILE_FAILED_CODE]: (
    state,
    { failedCode }
  ) => state.set(stateKeys.schoolPublicVacancies, failedCode),
  [types.SCHOOL_SET_SCHOOL_PUBLIC_VACANCIES_FAILED_CODE]: (
    state,
    { failedCode }
  ) => state.set(stateKeys.schoolPublicVacanciesFailedCode, failedCode),

  [types.SCHOOL_RESET_PUBLIC_VACANCIES]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/school/school-public-vacancies.js